<template>
	<v-card class="comment-edit-form elevation-0 mb-4" style="width: 100%">
		<v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validateAndSubmit">
			<div class="d-flex comment-edit-form__text-outer">
				<div style="width: 100%; background-color: #f6f6f6;">
					<v-textarea
						color="#000"
						class="comment-edit-form__textarea" rows='1'
						label="Your comment ..."
						:value="fields.content"
						v-model="fields.content"
						:error-messages="field_errors.content"
						:rules="rules.title"
						required
					></v-textarea>
					<v-btn
						:loading="loading"
						@click="validateAndSubmit"
						class="comment-edit-form__button"
					>
						Edit
					</v-btn>
				</div>
			</div>
			<p v-for="(index, error) in errors" :key="index" class="red--text">
				{{ error }}
			</p>
		</v-form>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from '@/mixins/Form'
import { ruleRequired } from '@/utils/rules'

export default {
	name: 'CommentEditForm',
	mixins: [Form],
	props: {
		comment: {
			type: Object,
			default: () => {},
		},
	},
	data: () => ({
		fields: {
			content: '',
		},
	}),
	methods: {
		...mapActions('post', ['editComment']),

		submitForm() {
			this.field_errors = {}

			const {thread_reply_id: commentId} = this.comment

			// return this.editComment({
			// 	commentId: commentId,
			// 	commentData: this.fields.content,
			// })
		},
	},
	computed: {
		...mapGetters('auth', ['isAuthenticated', 'profile']),
		rules() {
			return {
				content: [(v) => ruleRequired(v) || 'Field is required.'],
			}
		},
	},
	created() {
		this.fields = { ...this.fields, ...this.comment }
	},
}
</script>

<style lang="scss">
.comment-edit-form {
	font-family: Montserrat;
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 24px;
	letter-spacing: 0.5px;

	&__textarea {
		max-width: 654px;
		color: #000;
		border-radius: 20px;

		&:focus {
			.v-input__slot {
				border: 1px solid #000000;
			}
		}

		.v-input__slot {
			box-shadow: none !important;
		}
	}

	&__button {
		border-radius: 29px !important;
		background-color: var(--accent-color);
		color: #fff !important;
		text-transform: none;
	}
	@media screen and (max-width: 400px) {
		&__text-outer {
			flex-direction: column;
		}
	}
}

.v-label.v-label--active {
	top: 0 !important;
}
</style>
